import { Expose, plainToInstance, Type } from "class-transformer";

import { DocumentListItemModel } from "@documentation/models/document.model";

export type TreeNode = FolderModel | DocumentListItemModel;

/**
 * Lightweight model for displaying a folder in a list.
 */
export class FolderItemModel {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  creatorId!: string;

  @Expose()
  parentId!: string | null;

  @Expose()
  position!: number;

  @Expose()
  createdAt!: Date;

  @Expose()
  updatedAt!: Date;

  @Expose()
  isPublic!: boolean;

  constructor(data: Partial<FolderItemModel>) {
    Object.assign(this, data);
  }
}

export class FolderModel extends FolderItemModel {
  type: "folder" = "folder";

  @Expose()
  @Type(() => Object, {
    discriminator: {
      property: "type",
      subTypes: [
        { name: "folder", value: FolderModel },
        { name: "document", value: DocumentListItemModel }
      ]
    },
    keepDiscriminatorProperty: true
  })
  content!: TreeNode[];

  constructor(data: Partial<FolderModel>) {
    super(data);
    Object.assign(this, data);
  }
}

export class TreeNodeUnion {
  @Type(() => Object, {
    discriminator: {
      property: "type",
      subTypes: [
        { name: "folder", value: FolderModel },
        { name: "document", value: DocumentListItemModel }
      ]
    }
  })
  public nodes!: TreeNode[];

  static fromPlain(nodes: TreeNode[]): TreeNode[] {
    return plainToInstance(TreeNodeUnion, { nodes }).nodes;
  }
}
